var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({
    'background-color': _vm.useBackgroundColor,
    'padding-top': _vm.paddingTop + 'px',
    'padding-bottom': _vm.paddingBottom + 'px'
  })},[_c('div',{class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl },on:{"click":function($event){return _vm.$emit('block:redirect')}}},[_c('div',{staticClass:"columns columns--cards"},_vm._l((_vm.blocks),function(block,index){return _c('info-square',{key:index,staticClass:"column col-3 md-col-6 sm-col-12",attrs:{"fields":_vm.convertBlockFields(block),"is-content-reverse":_vm.isContentReverse,"body-link":_vm.blockParams?.bodyLink}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }